import Resources from '../../helpers/resources';
import {
  CORRECT, UNATTEMPTED, statusCodes, INCORRECT,
  ASSIGNED, UNASSIGNED, UNAVAILABLE, SCHEDULED_ASSIGN
} from '../../components/status-cell/utils';

export const getAllAssessments = async () => {
  const jsonData = await Resources.publications
    .get()
    .send();
  return jsonData;
};

export const getAssessments = async ({ courseId, courseVersion, i18n }) => {
  const jsonData = await Resources.genericCourses
    .get({ id: courseId, version: courseVersion })
    .send();
  return {
    ...jsonData,
    data: {
      topics: [{
        ...jsonData.data,
        id: jsonData.data.assessmentId,
        type: 'strand',
        externalKey: '',
        name: 'All domains',
        assessmentName: jsonData.data.name,
        childTopics: jsonData.data.topics.map(topic => ({
          ...topic,
          type: 'standard',
          name: topic.name,
          externalKey: '',
          childTopics: topic.questions.map(question => ({
            ...question,
            // eslint-disable-next-line prefer-template
            name: i18n.t`Question` + ' ' + question.position,
            type: 'learningjourney',
            id: question.resources.girlId
          }))
        }))
      }]
    }
  };
};

export const getAssignments = async ({
  productId,
  courseId,
  courseVersion,
  assessmentTypeId,
  studentUserProfileIds,
  learningJourneyIds
}) => {
  const jsonData = await Resources.studentassignments
    .post()
    .withBody({
      productId,
      assessmentId: courseId,
      version: courseVersion,
      type: assessmentTypeId,
      profileIds: studentUserProfileIds
    })
    .send();

  const assignmentResults = {};
  const studentsProgress = [];
  const studentsWithAssignments = [];
  const studentsWithScheduledAssignments = {};

  if (jsonData.data && jsonData.data.results) {
    jsonData.data.results.forEach((result) => {
      if (result.isExpired || result.handedIn) {
        studentsProgress.push({
          userProfileId: result.profileId,
          assignmentId: result.assignmentId,
          isReviewed: result.isReviewed,
          studentPct: result.studentPct
        });
      }

      result.correct.forEach((item) => {
        assignmentResults[`${result.profileId}_${item}`] = {
          assignmentStatus: statusCodes[CORRECT],
          assignmentId: result.assignmentId
        };
      });
      result.incorrect.forEach((item) => {
        assignmentResults[`${result.profileId}_${item}`] = {
          assignmentStatus: statusCodes[INCORRECT],
          assignmentId: result.assignmentId
        };
      });

      const hasAttempts = result.isStudentInProgress || result.handedIn || result.isExpired;
      const isScheduled = !result.isInProgress && !result.isExpired && !result.isStudentInProgress;
      let notAttemptedAssignmentStatus = statusCodes[ASSIGNED];
      if (isScheduled) {
        notAttemptedAssignmentStatus = statusCodes[SCHEDULED_ASSIGN];
        studentsWithScheduledAssignments[result.profileId] = {
          startDateTime: result.startDateTime,
          finishDateTime: result.finishDateTime
        };
      } else if (hasAttempts) {
        notAttemptedAssignmentStatus = statusCodes[UNATTEMPTED];
      }

      result.notAttempted.forEach((item) => {
        assignmentResults[`${result.profileId}_${item}`] = {
          assignmentStatus: notAttemptedAssignmentStatus,
          assignmentId: result.assignmentId
        };
      });

      studentsWithAssignments.push(result.profileId);
    });
  }

  const assignmentStatuses = [];
  studentUserProfileIds.forEach((studentProfileId) => {
    const hasAssignment = studentsWithAssignments.includes(studentProfileId);
    const assignmentStatusForUnassignedQuestions = hasAssignment ? statusCodes[UNAVAILABLE] : statusCodes[UNASSIGNED];
    const { startDateTime, finishDateTime } = studentsWithScheduledAssignments[studentProfileId] || {};
    learningJourneyIds.forEach((learningJourneyId) => {
      const assignmentResult = assignmentResults[`${studentProfileId}_${learningJourneyId}`];
      assignmentStatuses.push({
        learningJourneyId,
        studentProfileId,
        needsAttention: false,
        stepsCompleted: 0,
        stepsCount: 0,
        studentStatus: assignmentResult ? assignmentResult.assignmentStatus : assignmentStatusForUnassignedQuestions,
        assignmentId: assignmentResult ? assignmentResult.assignmentId : null,
        startDateTime,
        finishDateTime
      });
    });
  });

  return {
    ...jsonData,
    data: {
      assignmentStatuses,
      studentsProgress
    }
  };
};

